<template>
	<el-dialog title="年度评价历史" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="550px">
		<el-table :data="showList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border>
			<el-table-column label="序号" align="center" width="60">
				<template slot-scope="scope">
					{{ scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="lockDate" label="锁定日期">
				<template slot-scope="scope">
					<span>{{ scope.row.lockDate ? $moment(scope.row.lockDate).format("YYYY/MM/DD") : "" }}</span>
				</template>
			</el-table-column>
			<el-table-column label="锁定人" align="center" prop="lockBy"></el-table-column>
			<el-table-column prop="lockDate" label="发证日期">
				<template slot-scope="scope">
					<span>{{ scope.row.issueDate ? $moment(scope.row.issueDate).format("YYYY/MM/DD") : "" }}</span>
				</template>
			</el-table-column>
			<el-table-column label="锁定评价结果" align="center" prop="levelName"></el-table-column>
		</el-table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="dialogVisible = false">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { courseSkillLockHistory } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			lockId: "",
			showList: [],
		};
	},
	methods: {
		// 初始化弹窗
		init(lockId) {
			this.dialogVisible = true;
			this.lockId = lockId;
			this.getList();
		},
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取列表
		getList() {
			courseSkillLockHistory({ lockId: this.lockId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.showList = res.data;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.el-table ::v-deep td,
.el-table ::v-deep th {
	padding: 5px 0;
}
::v-deep .el-dialog__body {
	padding: 0 15px 15px;
}
</style>
